import React from "react";
import OdooServices from "./OdooServices";
import HeroSection from "../common/HeroSection";
import ServiceSidebar from "../services/ServiceSidebar";
import {
  BookOpen,
  ChartNoAxesColumn,
  CircleCheckBig,
  Code,
  Database,
  Layers,
  PanelsTopLeft,
  PenTool,
  RefreshCw,
  Settings,
  Users,
  Zap,
} from "lucide-react";
import { Link } from "react-router-dom";

export default function OdooCustomization() {
  return (
    <div>
      <HeroSection
        title="Odoo Customization Services"
        breadcrumb={[
          { name: "Services", url: "/services" },
          { name: "Odoo Services", url: "/services/odoo-services" },
          {
            name: "Odoo Customization",
            url: "/services/odoo-services/odoo-customization",
          },
        ]}
        background="/assets/images/career.jpg"
      />
      <div className="bg-white">
        <div className="py-16 px-4 mx-auto container">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 px-4">
          {/* Sidebar (OdooServices) */}
          <OdooServices />

          {/* <!-- Content Section --> */}

          <div className="lg:col-span-2 ">
            <div className="">
              <div className="relative rounded-xl overflow-hidden mb-8">
                <img
                  alt="Odoo Customization Services"
                  loading="lazy"
                  width="700"
                  height="450"
                  decoding="async"
                  data-nimg="1"
                  className="w-full h-auto object-cover rounded-xl"
                  src="/assets/images/odoo/odoo-erp-customization.png"
                />
              </div>
              <div className="mb-8">
                <span className="text-primary font-medium text-lg inline-block py-1 font-bold rounded-full bg-primary bg-opacity-10 mb-3">
                  Tailored Solutions
                </span>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
                  Odoo <span className="text-primary">Customization</span>{" "}
                  Services
                </h2>
                <div className="prose prose-lg max-w-none text-gray-600">
                  <p>
                    While Odoo provides an extensive range of business
                    applications out of the box, every business has unique
                    processes and requirements that may need specialized
                    solutions. Our Odoo customization services enable you to
                    tailor the Odoo platform precisely to your business needs.
                  </p>
                  <p>
                    At{" "}
                    <span className="text-primary font-medium">
                      TISSA Technology
                    </span>
                    , we have a team of experienced Odoo developers who can
                    modify existing modules, create entirely new modules,
                    customize the user interface, and build specialized
                    workflows to meet your specific business requirements. Our
                    customization services ensure that your Odoo implementation
                    perfectly matches your business processes, giving you a
                    competitive edge.
                  </p>
                  <p>
                    Whether you need simple enhancements to standard modules or
                    complex custom functionality development, our team can
                    deliver high-quality, maintainable, and upgrade-safe
                    customizations that extend Odoo's capabilities while
                    preserving its core benefits.
                  </p>
                </div>
              </div>
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Our Odoo Customization Services
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <Code className="h-6 w-6 text-primary" />
                      
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Custom Module Development
                    </h4>
                    <p className="text-gray-600">
                      Development of new Odoo modules to add industry-specific
                      or business-specific functionalities that aren't available
                      in standard modules.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <PenTool className="h-6 w-6 text-primary" />
                      
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Existing Module Modification
                    </h4>
                    <p className="text-gray-600">
                      Customization of standard Odoo modules to adapt them to
                      your specific business requirements and workflows.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <PanelsTopLeft className="h-6 w-6 text-primary" />
                     
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      UI/UX Customization
                    </h4>
                    <p className="text-gray-600">
                      Enhancement of Odoo's user interface and user experience
                      to improve usability, match your brand identity, and
                      optimize user productivity.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <Zap className="h-6 w-6 text-primary" />
                     
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Business Process Automation
                    </h4>
                    <p className="text-gray-600">
                      Creation of custom automation rules, workflows, and
                      triggers to streamline operations and reduce manual tasks.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <Settings className="h-6 w-6 text-primary" />
                      
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      Reporting &amp; Dashboard Customization
                    </h4>
                    <p className="text-gray-600">
                      Development of custom reports and dashboards to provide
                      actionable insights tailored to your business needs.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100 hover:shadow-md transition-shadow duration-300">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-full inline-flex items-center justify-center mb-4">
                      <RefreshCw className="h-6 w-6 text-primary" />
                     
                    </div>
                    <h4 className="text-xl font-semibold text-gray-800 mb-2">
                      API &amp; Integration Development
                    </h4>
                    <p className="text-gray-600">
                      Building custom APIs and integration points to connect
                      Odoo with other business systems and third-party
                      applications.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Our Customization Approach
                </h3>
                <div className="space-y-6">
                  <div className="bg-white p-6 rounded-xl shadow-soft border-l-4 border-primary">
                    <h4 className="text-xl font-bold text-gray-800 mb-2">
                      1. Requirements Analysis
                    </h4>
                    <p className="text-gray-600">
                      We conduct a thorough analysis of your business needs,
                      current processes, and customization requirements to
                      identify the specific areas where standard Odoo
                      functionality needs to be enhanced or extended.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border-l-4 border-primary">
                    <h4 className="text-xl font-bold text-gray-800 mb-2">
                      2. Solution Design
                    </h4>
                    <p className="text-gray-600">
                      Our technical team designs a customization solution that
                      addresses your requirements while maintaining
                      compatibility with the core Odoo platform. We create
                      detailed specifications and mockups for review and
                      approval.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border-l-4 border-primary">
                    <h4 className="text-xl font-bold text-gray-800 mb-2">
                      3. Development
                    </h4>
                    <p className="text-gray-600">
                      Our experienced Odoo developers write clean,
                      well-documented code to implement the custom features. We
                      follow best practices and coding standards to ensure
                      high-quality, maintainable customizations.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border-l-4 border-primary">
                    <h4 className="text-xl font-bold text-gray-800 mb-2">
                      4. Testing
                    </h4>
                    <p className="text-gray-600">
                      Every customization undergoes rigorous testing, including
                      unit tests, integration tests, and user acceptance testing
                      to ensure it functions correctly and doesn't negatively
                      impact other parts of the system.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border-l-4 border-primary">
                    <h4 className="text-xl font-bold text-gray-800 mb-2">
                      5. Deployment
                    </h4>
                    <p className="text-gray-600">
                      We carefully implement the customizations in your Odoo
                      environment, following change management best practices to
                      minimize business disruption.
                    </p>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border-l-4 border-primary">
                    <h4 className="text-xl font-bold text-gray-800 mb-2">
                      6. Documentation &amp; Knowledge Transfer
                    </h4>
                    <p className="text-gray-600">
                      We provide comprehensive documentation for all
                      customizations and train your team on the new features to
                      ensure smooth adoption and ongoing support.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Benefits of Odoo Customization
                </h3>
                <div className="bg-gray-50 p-6 rounded-xl border-l-4 border-primary">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex items-start">
                     <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">
                        Perfect alignment between software functionality and your business processes
                      </span>
                    </div>
                    <div className="flex items-start">
                      <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">
                        Improved user adoption and satisfaction with tailored
                        user interfaces
                      </span>
                    </div>
                   
                     <div className="flex items-start">
                   <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">
                        Enhanced productivity through streamlined and automated
                        workflows
                      </span>
                    </div>
                     <div className="flex items-start">
                     <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">
                        Competitive advantage with unique functionalities
                        specific to your business
                      </span>
                    </div>
                     <div className="flex items-start">
                   <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">
                        Better decision-making with customized reports and
                        analytics
                      </span>
                    </div>
                    <div className="flex items-start">
                     <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">
                        Increased system flexibility to adapt to changing
                        business needs
                      </span>
                    </div>
                    <div className="flex items-start">
                     <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">
                        Seamless integration with industry-specific tools and
                        third-party applications
                      </span>
                    </div>
                    <div className="flex items-start">
                     <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">
                        Optimized business processes that drive efficiency and
                        reduce operational costs
                      </span>
                    </div>
                      
                    
                   
                   
                  </div>
                </div>
              </div>

              <div className="mb-12">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">
                  Industry-Specific Customizations
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100">
                    <h4 className="text-xl font-bold text-primary mb-4">
                      Manufacturing
                    </h4>
                    <ul className="space-y-2">
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Custom production planning and scheduling modules
                        </span>
                      </li>
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Advanced quality control processes and checklists
                        </span>
                      </li>
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Equipment maintenance and downtime tracking
                        </span>
                      </li>
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Custom bill of materials and routing management
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100">
                    <h4 className="text-xl font-bold text-primary mb-4">
                      Retail &amp; E-commerce
                    </h4>
                    <ul className="space-y-2">
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Advanced pricing and promotion engines
                        </span>
                      </li>
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Custom loyalty and rewards programs
                        </span>
                      </li>
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Specialized inventory and warehouse management
                        </span>
                      </li>
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Omnichannel order processing and fulfillment
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100">
                    <h4 className="text-xl font-bold text-primary mb-4">
                      Professional Services
                    </h4>
                    <ul className="space-y-2">
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Advanced time tracking and billing solutions
                        </span>
                      </li>
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Project profitability and resource allocation tools
                        </span>
                      </li>
                      <li className="flex items-start">
                       <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Custom client onboarding and management workflows
                        </span>
                      </li>
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Specialized reporting for service delivery metrics
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100">
                    <h4 className="text-xl font-bold text-primary mb-4">
                      Healthcare
                    </h4>
                    <ul className="space-y-2">
                      <li className="flex items-start">
                       <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Patient management and appointment scheduling
                        </span>
                      </li>
                      <li className="flex items-start">
                        <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Medical inventory and equipment tracking
                        </span>
                      </li>
                      <li className="flex items-start">
                       <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Compliance and regulatory reporting tools
                        </span>
                      </li>
                      <li className="flex items-start">
                       <CircleCheckBig className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">
                          Healthcare-specific billing and insurance processing
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div>
                <div className="mb-12">
                  <h3 className="text-2xl font-bold text-gray-800 mb-6">
                    Success Story
                  </h3>
                  <div className="bg-white p-6 rounded-xl shadow-soft border border-gray-100">
                    <h4 className="text-xl font-bold text-primary mb-4">
                      Logistics Company Custom Solution
                    </h4>
                    <p className="text-gray-600 mb-4">
                      A logistics company was struggling to manage their
                      specialized delivery processes with standard Odoo
                      functionality. They needed a solution that could handle
                      complex routing, real-time driver tracking, and custom
                      delivery rules that varied by customer.
                    </p>
                    <p className="text-gray-600 mb-4">
                      Our team developed custom Odoo modules that integrated
                      with their GPS tracking systems and implemented
                      sophisticated routing algorithms. We created a custom
                      driver mobile interface and customer-specific delivery
                      rule engine that automated their complex delivery
                      workflows.
                    </p>
                    <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="bg-gray-50 p-4 rounded-lg text-center">
                        <div className="text-primary font-bold text-2xl">40%</div>
                        <div className="text-gray-600">
                          Increase in Delivery Efficiency
                        </div>
                      </div>
                      <div className="bg-gray-50 p-4 rounded-lg text-center">
                        <div className="text-primary font-bold text-2xl">60%</div>
                        <div className="text-gray-600">
                          Reduction in Dispatch Time
                        </div>
                      </div>
                      <div className="bg-gray-50 p-4 rounded-lg text-center">
                        <div className="text-primary font-bold text-2xl">28%</div>
                        <div className="text-gray-600">
                          Cost Savings in Operations
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-8 rounded-xl border border-blue-100">
                  <h4 className="text-2xl font-bold text-gray-800 mb-3">
                    Need Custom Odoo Solutions for Your Business?
                  </h4>
                  <p className="text-gray-600 mb-6">
                    Contact our Odoo customization experts today to discuss how
                    we can tailor Odoo to perfectly match your unique business
                    requirements.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4">
                    <Link
                      className="inline-block text-blue-700 font-bold bg-primary hover:bg-primary-dark font-medium py-3 px-6 rounded-lg transition-colors duration-300"
                      to="/contact-us/"
                    >
                      Request a Free Consultation
                    </Link>
                    <Link
                      className="inline-block border border-primary text-primary hover:bg-blue-700 hover:text-white font-medium py-3 px-6 rounded-lg transition-colors duration-300"
                      to="/services/odoo-services/"
                    >
                      Explore All Odoo Services
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
              Frequently Asked Questions
            </h2>
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  Will customizations impact future Odoo upgrades?
                </h3>
                <p className="text-gray-600">
                  When developed properly, customizations can be upgrade-safe.
                  Our team follows Odoo's best practices and coding standards to
                  ensure that customizations are developed in a way that
                  minimizes conflicts during future upgrades. We create separate
                  custom modules rather than modifying core files, use proper
                  inheritance mechanisms, and maintain comprehensive
                  documentation to facilitate smooth upgrades.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  How do you ensure the quality of customizations?
                </h3>
                <p className="text-gray-600">
                  We follow a rigorous quality assurance process for all
                  customizations. This includes code reviews by senior
                  developers, comprehensive automated and manual testing,
                  performance optimization, and security assessments. We also
                  provide extensive documentation and follow Odoo coding
                  standards and best practices to ensure maintainable,
                  high-quality code.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  Can you customize our existing Odoo installation?
                </h3>
                <p className="text-gray-600">
                  Yes, we can customize your existing Odoo installation. Our
                  team will first conduct a thorough assessment of your current
                  setup, including any previous customizations, to understand
                  the current state and identify any potential issues. We then
                  develop and implement new customizations that integrate
                  seamlessly with your existing system while maintaining
                  stability and performance.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  How long does Odoo customization typically take?
                </h3>
                <p className="text-gray-600">
                  The timeline for Odoo customization varies based on the
                  complexity and scope of the customization requirements. Simple
                  customizations like adding fields or modifying reports might
                  take a few days, while complex custom modules with unique
                  business logic could take several weeks to develop. During our
                  initial consultation, we'll provide a detailed timeline
                  estimate based on your specific requirements.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-soft">
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  Do you provide support for customizations after deployment?
                </h3>
                <p className="text-gray-600">
                  Yes, we provide ongoing support for all our customizations. We
                  offer various support packages that include regular
                  maintenance, bug fixes, enhancements, and assistance with any
                  issues that may arise. Our team is also available to help with
                  future changes to the customizations as your business
                  requirements evolve over time.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
